import React from "react";
import * as PropTypes from 'prop-types';
const CILabel = ({label,value})=>{
    return (
        <div className="d-flex flex-column">
            <label className="mt-3 form-label">{label}</label>
            <span style={{fontSize:'16px'}}>{value}</span>
        </div>
    )
}

CILabel.prototype ={
    label:PropTypes.string,
    value:PropTypes.string
}

export default CILabel;